<template>
	<el-dropdown @visible-change="showScorll" style="margin-right: 30px">
		<div class="info-box">
			<el-icon :size="20"><ChatRound /></el-icon>
			<div class="dian" v-if="msgNum > 0 || otherNum > 0"></div>
		</div>
		<template #dropdown>
			<div class="msgBox" v-loading="msgLoading">
				<el-tabs :model-value="activeNameMsg" @update:model-value="updateActiveNameMsg">
					<el-tab-pane :label="'公告信息(' + msgNum + ')'" name="公告">
						<div
							class="msg-list"
							v-infinite-scroll="load"
							infinite-scroll-immediate="false"
							v-if="msgList.length > 0"
						>
							<div
								class="msgItem"
								v-for="(item, index) in msgList"
								:key="index"
								@click="messageReaded(item, index)"
							>
								<div class="itemDe" :class="item.is_yue == 2 ? 'unread' : 'read'">
									{{ item.title }}
								</div>
								<div class="itemDate">
									{{ item.create_time ? item.create_time : item.send_time }}
								</div>
							</div>
						</div>
						<div class="null" v-else>
							<el-empty description="暂无公告" />
						</div>
					</el-tab-pane>
					<el-tab-pane :label="'其他信息' + '(' + otherNum + ')'" name="其他信息">
						<div
							class="msg-list"
							v-infinite-scroll="loadOther"
							infinite-scroll-immediate="false"
							v-if="otherList.length > 0"
						>
							<div
								class="msgItem"
								v-for="(item, index) in otherList"
								:key="index"
								@click="messageReadedOther(item, index)"
							>
								<div class="itemDe" :class="item.is_read == 2 ? 'unread' : 'read'">
									<MyToolTip
										placement="right-start"
										effect="light"
										:content="item.title"
									></MyToolTip>
								</div>
								<div class="itemDate">
									{{ item.send_time ? item.send_time : item.send_time }}
								</div>
							</div>
						</div>
						<div class="null" v-else>
							<el-empty description="暂无其他信息" />
						</div>
					</el-tab-pane>
				</el-tabs>
				<div class="readedAll" @click="readAllFun" v-if="msgNum > 0 || otherNum > 0">
					一键已读
				</div>
			</div>
		</template>
	</el-dropdown>
</template>

<script setup>
import { ChatRound } from '@element-plus/icons-vue'
import MyToolTip from '@/components/common/proToolTip'

// Props
const props = defineProps({
	msgNum: {
		type: Number,
		default: 0
	},
	otherNum: {
		type: Number,
		default: 0
	},
	msgLoading: {
		type: Boolean,
		default: false
	},
	activeNameMsg: {
		type: String,
		default: '公告'
	},
	msgList: {
		type: Array,
		default: () => []
	},
	otherList: {
		type: Array,
		default: () => []
	},
	show_scroll: {
		type: Boolean,
		default: false
	}
})

// Emits
const emit = defineEmits([
	'update:activeNameMsg',
	'show-scroll',
	'message-readed',
	'message-readed-other',
	'load',
	'load-other',
	'read-all'
])

// Methods
const updateActiveNameMsg = (value) => {
	emit('update:activeNameMsg', value)
}

const showScorll = () => {
	emit('show-scroll')
}

const messageReaded = (item, index) => {
	emit('message-readed', item, index)
}

const messageReadedOther = (item, index) => {
	emit('message-readed-other', item, index)
}

const load = () => {
	emit('load')
}

const loadOther = () => {
	emit('load-other')
}

const readAllFun = () => {
	emit('read-all')
}
</script>

<style scoped lang="scss">
.info-box {
	position: relative;
	cursor: pointer;
	display: flex;
	align-items: center;
}

.dian {
	background-color: red;
	border-radius: 50%;
	position: absolute;
	width: 5px;
	height: 5px;
	top: 0px;
	right: 0px;
}

.msgBox {
	box-sizing: border-box;
	padding: 10px 20px;
}

.msg-list {
	width: 500px;
	height: 500px;
	overflow-y: auto;
}

.msgItem {
	display: flex;
	padding: 10px;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;
	
	.unread {
		color: #000;
	}
	
	.read {
		color: #747474;
	}
	
	.itemDe {
		width: 300px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}

.null {
	width: 500px;
	height: 500px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.readedAll {
	position: absolute;
	right: 20px;
	top: 20px;
	color: red;
	cursor: pointer;
	font-size: 13px;
}

.readedAll:hover {
	transform: scale(1.2);
}

:deep(.el-tabs__nav-wrap::after) {
	position: static !important;
}
</style> 